import { useEffect, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Nav } from "@/components/public/Nav";
import { Hero } from "@/components/public/Hero";
import { Highlights, Schedule } from "@/components/public/Program";
import { Location } from "@/components/public/Location";
import { Gallery } from "@/components/public/Gallery";
import { JoinSection } from "@/components/public/JoinSection";
import { DonationThanks } from "@/components/public/DonationThanks";
import { VendorSection } from "@/components/public/VendorSection";
import { ContactSection, Footer } from "@/components/public/Contact";

export default function PublicPage() {
  const [content, setContent] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    document.title = "Egúngún Festival 2026 – Ilesa Ire";
    api.get("/content").then((r) => setContent(r.data)).catch(() => setFailed(true));
  }, []);

  useEffect(() => {
    const logo = content?.images?.logo;
    const link = document.getElementById("app-favicon");
    if (logo && link) link.href = imgUrl(logo.url);
  }, [content]);

  if (!content)
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-neutral-950" data-testid="public-loading">
        <div className="kente kente-band w-40 animate-pulse" />
        <p className="font-display text-neutral-500">{failed ? "Unable to load. Please refresh." : "Loading…"}</p>
      </div>
    );

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100" data-testid="public-page">
      <Nav content={content} />
      <main>
        <Hero content={content} />
        <Schedule content={content} />
        <Highlights content={content} />
        <Location content={content} />
        <Gallery content={content} />
        <JoinSection content={content} />
        <ContactSection content={content} />
        <VendorSection content={content} />
      </main>
      <Footer content={content} />
      <DonationThanks />
    </div>
  );
}
